/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Arch_X86Inputs */

const en_fc_dl_arch_x86 = /** @type {(inputs: Fc_Dl_Arch_X86Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x86 (32-bit)`)
};

/**
* | output |
* | --- |
* | "x86 (32-bit)" |
*
* @param {Fc_Dl_Arch_X86Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_arch_x86 = /** @type {((inputs?: Fc_Dl_Arch_X86Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Arch_X86Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_arch_x86(inputs)
});
export { fc_dl_arch_x86 as "fc.dl.arch.x86" }